import { useState } from 'react';
import format from 'date-fns/format';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import ViewIcon from '@material-ui/icons/Visibility';
import DownloadIcon from '@material-ui/icons/CloudDownload';

import Button from 'components/CncUI/Button';
import DataTable from 'components/CncUI/DataTable';
import FileViewer from 'components/FileViewer';
import FileDownloader from 'components/FileDownloader';
import useGetW4Url from '../hooks/useGetW4Url';

import useQuery from 'hooks/useQuery';
import base64ToArrayBuffer from 'utilities/base64ToArrayBuffer';

const useStyles = makeStyles(() => ({
  cellText: {
    textTransform: 'capitalize',
  },
  header15: {
    width: '15%',
  },
  header20: {
    width: '20%',
  },
  header25: {
    width: '25%',
  },
}));

const W4Documents = props => {
  const classes = useStyles();
  const [downloader, setDownloader] = useState('');
  const [viewer, setViewer] = useState('');
  const getW4Url = useGetW4Url();
  const getW4File = useQuery('getW4File', {
    scopes: 'users:read',
    request: id => ({ id }),
    response: res => {
      const data = res.data.getW4File || '';
      if (data) {
        const arraybuffer = base64ToArrayBuffer(data);
        const fileBlob = new Blob([arraybuffer], { type: 'application/pdf' });
        return URL.createObjectURL(fileBlob);
      }
      return '';
    },
  });
  const { data, tab } = props;

  const formatDate = timestamp => {
    const date = new Date(parseInt(timestamp, 10));
    return format(date, 'MM/dd/yyyy HH:mm:ss');
  };

  const columns = [
    {
      field: 'name',
      headerProps: { className: classes.header25 },
    },
    {
      field: 'status',
      cellProps: { className: classes.cellText },
      headerProps: { className: classes.header20 },
    },
    {
      field: 'stateId',
      label: tab === 3 ? 'Province' : 'State',
      value: ({ stateId }) => (stateId ? stateId : 'Federal'),
      headerProps: { className: classes.header20 },
    },
    {
      field: 'createdAt',
      label: 'Created',
      value: ({ createdAt }) => formatDate(createdAt),
      headerProps: { className: classes.header20 },
    },
    {
      field: 'actions',
      label: ' ',
      sortable: false,
      headerProps: { className: classes.header15 },
      value: doc =>
        (doc.lastLevelHistoryProcessed && (
          <Grid container spacing={1} justify="flex-end">
            <Grid item>
              <Button
                circle
                tertiary
                short
                title="View document"
                onClick={() => setViewer(doc.documentId)}
                id={`ViewW4Icon-${doc.id}`}
              >
                <ViewIcon />
              </Button>
            </Grid>
            <Grid item>
              <Button
                circle
                tertiary
                short
                title="Download document"
                onClick={() => setDownloader(doc.documentId)}
                id={`DownloadW4Icon-${doc.id}`}
              >
                <DownloadIcon />
              </Button>
            </Grid>
          </Grid>
        )) ||
        doc.lastLevelHistoryProcessed,
    },
  ];

  return (
    <>
      {viewer && (
        <FileViewer
          fileFetcher={getW4File}
          config={viewer}
          onClose={() => setViewer('')}
        />
      )}
      {downloader && (
        <FileDownloader
          urlFetcher={getW4Url}
          config={{ documentId: downloader }}
          onClose={() => setDownloader('')}
        />
      )}
      <DataTable
        transparent
        columns={columns}
        data={data || []}
        sort="createdAt"
        order="desc"
        emptyRows={`No ${tab === 3 ? 'TD1' : 'W-4'} documents to show`}
      />
    </>
  );
};

export default W4Documents;
